import { useRequiredContext } from "@redotech/react-util/context";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  addressesAreDifferent,
  formatAddress,
} from "@redotech/redo-fulfillment-operations-common/csv-columns/address-verification-csv";
import AlertTriangleIcon from "@redotech/redo-icons/alert-triangle.svg";
import DotIcon from "@redotech/redo-icons/dot-01.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";

export const AddressVerificationCell = memo(function AddressVerificationCell({
  row,
}: {
  row: FulfillmentGroupData;
}) {
  const team = useRequiredContext(TeamContext);
  if (!team) {
    return null;
  }

  const needsVerificationBadge = (
    <Tooltip
      placement="bottom-start"
      title={`Suggested Address:\n${formatAddress(row.verifiedDestinationAddress)}`}
    >
      <div>
        <RedoBadge
          color="warning"
          segmentLeading={{ type: "icon", Icon: DotIcon }}
          size="xs"
          text="Needs Verification"
        />
      </div>
    </Tooltip>
  );

  if (!row.verifiedDestinationAddress) {
    return null;
  }

  const autoClean =
    team.settings?.outboundLabels?.address?.autoCleanAddresses &&
    !row.overrideUseOriginalDestinationAddress;

  return row.verifiedDestinationAddress?.verified ? (
    addressesAreDifferent(
      row.destinationAddress,
      row.verifiedDestinationAddress,
    ) && !autoClean ? (
      needsVerificationBadge
    ) : (
      <RedoBadge
        color="success"
        segmentLeading={{ type: "icon", Icon: DotIcon }}
        size="xs"
        text="Verified"
      />
    )
  ) : (
    <Tooltip
      placement="bottom-start"
      title={row.verifiedDestinationAddress?.messages?.join(", ") ?? ""}
    >
      <div>
        <RedoBadge
          color="error"
          segmentLeading={{ type: "icon", Icon: AlertTriangleIcon }}
          size="xs"
          text="Error"
        />
      </div>
    </Tooltip>
  );
});
